// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPsClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#ps-clock_svg__a)"
    >
      <path d="M1.371 12C1.371 6.13 6.13 1.371 12 1.371c5.87 0 10.628 4.759 10.628 10.629 0 5.87-4.758 10.629-10.628 10.629S1.37 17.87 1.37 12z" />
      <path d="M3.048 12a8.952 8.952 0 1 1 17.904 0 8.952 8.952 0 0 1-17.904 0z" />
      <path d="M14.184 5.61 12 12.188V7.982M12 3.998v-.95M6.37 6.34l-.665-.666M4.028 11.97h-.95M6.37 17.599l-.665.665M12 20.89v-.95M17.629 17.599l.665.665M19.97 11.97h.95M18.294 5.674l-.665.665" />
    </g>
    <defs>
      <clipPath id="ps-clock_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPsClock;
